import { useContext } from 'react';

import { LoginContext } from './context';

export function useLogin() {
  const login = useContext(LoginContext);

  return login;
}
